import { useState } from "react";
import moment from "moment/moment";
// @ts-expect-error pure js
import ToggleSwitch from "../UI/ToggleSwitch";
import CollapsibleCard from "../UI/CollapsibleCard";
import Text from "../UI/Text";
// @ts-expect-error pure js
import { useModal } from "../../hooks/use-modal.jsx";
// @ts-expect-error pure js
import ActionForm from "./ActionForm";
// @ts-expect-error pure js
import { AutoActionType } from "../../utils/constants/autoActions";
// @ts-expect-error pure js
import { getFormattedCommentaires } from "../../utils/actions";
import {
  type AutoAction,
  type AutoActionAssociation,
} from "../../hooks/use-auto-actions";
import IconButton from "../UI/IconButton.tsx";
import { IconEdit } from "@tabler/icons-react";
import styles from "./Action.module.css";

interface ActionProps {
  action: AutoAction | Pick<AutoAction, "nom" | "static_id" | "commentaires">;
  checked: boolean;
  onToggle: (
    e: React.ChangeEvent<HTMLInputElement>,
    action: ActionProps["action"],
    tenantAutoAction?: AutoActionAssociation,
  ) => void;
  autoActionAssociation?: AutoActionAssociation;
  onUpdate: (id: number, values: Record<string, unknown>) => Promise<unknown>;
  disabled?: boolean;
  requiresWrite?: boolean;
}

export default function Action({
  action,
  checked,
  onToggle,
  autoActionAssociation,
  onUpdate,
  disabled,
  requiresWrite,
}: ActionProps) {
  const [Modal, closeModal, openModal] = useModal();
  const [autoAction, setAutoAction] = useState<AutoActionAssociation | null>(
    null,
  );

  async function updateAutoActionHandler(values: Record<string, unknown>) {
    if (!autoAction) return;
    await onUpdate(autoAction.id, values);
    closeModal();
  }

  return (
    <>
      <ActionForm
        ModalElement={Modal}
        onSubmit={updateAutoActionHandler}
        action={autoAction}
      />
      <CollapsibleCard
        title={action.nom}
        headerActions={
          <ToggleSwitch
            status={checked}
            onToggle={(e: React.ChangeEvent<HTMLInputElement>) =>
              onToggle(e, action, autoActionAssociation)
            }
            disabled={disabled}
            requiresWrite={requiresWrite}
          />
        }
      >
        <div className={styles.nextOccurence}>
          <Text variant="deci" color="muted">
            Prochaine occurrence :{" "}
            <Text variant="deci" weight="medium" as="span">
              {!autoActionAssociation && "non activé"}
              {autoActionAssociation &&
                (autoActionAssociation.action_date
                  ? moment(autoActionAssociation.action_date).format(
                      "DD/MM/YYYY",
                    )
                  : "non prédéfini")}
            </Text>
          </Text>
          {[AutoActionType.RETARD_LOYER, AutoActionType.AVIS_ECHEANCE].includes(
            action.static_id,
          ) && (
            <IconButton
              onClick={() => {
                openModal();
                setAutoAction(autoActionAssociation ?? null);
              }}
              icon={IconEdit}
              label="Modifier la date d'exécution"
              disabled={!autoActionAssociation}
              requiresWrite={requiresWrite}
            />
          )}
        </div>
        <Text
          as="div"
          variant="deci"
          color="muted"
          className={styles.description}
          dangerouslySetInnerHTML={{
            __html: getFormattedCommentaires(action, autoActionAssociation),
          }}
        />
      </CollapsibleCard>
    </>
  );
}
